<div class="ssn-verification-modal-component" id="ssnVerificationModal">
	<app-white-verification-modal
		(action)="getAction($event)"
		[title]="title"
		[showCloseIcon]="true"
		[showButtons]="showButtons">
		<ng-container>
			<div *ngIf="!showCouldNotVerifySsn">
				<p>
					Please provide your Social Security number below to verify your identity. Once we authenticate, you will have
					full access to all your health documents.
				</p>
				<div class="row">
					<div class="col-md-8 {{ errorMessage.show ? 'pb-3' : '' }}">
						<form [formGroup]="ssnVerification">
							<mat-form-field class="form-group w-100">
								<mat-label>{{ 'registration.create-account.form.social-security-number' | translate }}</mat-label>
								<input
									matInput
									formControlName="ssn"
									formControlName="ssn"
									type="text"
									appMaskSSN
									[ssnFormGroup]="ssnVerification"
									[ssnControlName]="'ssn'"
									[ShowSSNValue]="showhideSSNVal" />
								<i class="toggle-ssn {{ showhideSSNVal ? 'show' : 'hide' }}" (click)="showHideSSN()">
									<svg
										class="icon"
										height="512"
										viewBox="0 0 1024 1024"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M1023.997 511.831c0 99.79-211.129 312.67-511.999 312.67C218.787 824.501 0 615.125 0 511.831c0-103.279 219.73-312.334 511.999-312.334 303.234 0.001 512.071 209.057 511.999 312.335L1023.998 511.831zM512.45 256.529C376.184 256.529 265.72 370.913 265.72 512c0 141.089 110.463 255.471 246.729 255.471 136.307 0 246.774-114.383 246.774-255.471C759.223 370.913 648.756 256.529 512.45 256.529L512.45 256.529zM511.999 348.901c-86.778 0-157.126 72.827-157.126 162.673 0 89.836 70.348 162.677 157.126 162.677s157.097-72.841 157.097-162.677C669.096 421.727 598.776 348.901 511.999 348.901L511.999 348.901z" />
									</svg>
								</i>
								<mat-error>
									<app-error-message [control]="'ssn'"></app-error-message>
									<p class="error-message" *ngIf="errorMessage.show">
										The number you entered does not match our records. Please try again. You have
										{{ errorMessage?.attempt }} more attempt(s) left.
									</p>
								</mat-error>
							</mat-form-field>
						</form>
					</div>
				</div>
			</div>
			<div *ngIf="showCouldNotVerifySsn">
				<p>
					To access all your health documents, please call 800.362.8671 or email MemberServices&#64;ehe.health for
					assistance.
				</p>
			</div>
		</ng-container>
	</app-white-verification-modal>
</div>
<app-ehe-spinner></app-ehe-spinner>
